import * as React from 'react';

export const CurrencyExchange: React.FunctionComponent = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9978 7.03265C11.3661 6.91064 11.7301 7.20811 11.9785 7.32458L12.3708 6.5968C12.0759 6.44575 11.8847 6.29977 11.5005 6.2129V5.79999H10.6737V6.27254C9.99767 6.53278 9.73413 7.52912 10.3295 7.99385C10.5772 8.18811 10.9265 8.32629 11.2671 8.44667C11.4283 8.50366 11.4967 8.61241 11.4702 8.76983C11.4499 8.89078 11.3457 9.09593 11.0844 9.09767C10.8118 9.09935 10.7475 9.0894 10.5486 8.95924L10.2026 8.73292L9.75 9.42477L10.0959 9.65108C10.3133 9.79326 10.4856 9.86403 10.6737 9.89746V10.3472H11.5005V9.85074C12.4977 9.49606 12.6126 8.03502 11.5426 7.66719C11.2816 7.57495 10.994 7.46433 10.8398 7.34335C10.7869 7.25557 10.868 7.0795 10.9978 7.03265Z"
        fill="#3A3A3A"
      />
      <path
        d="M3.55275 7.60865H2.8V8.43542H3.56364C3.76672 9.37926 4.60738 10.089 5.61102 10.089H6.02441V9.26219H5.61102C5.06701 9.26219 4.60203 8.91767 4.42254 8.43542H5.51512V7.60865H4.40355C4.5672 7.09773 5.04653 6.72676 5.61102 6.72676H6.02441V5.89999H5.61102C4.58798 5.89999 3.73442 6.6375 3.55275 7.60865Z"
        fill="#3A3A3A"
      />
      <circle cx="5" cy="8" r="3.5" stroke="#404040" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.58383 9.77856C8.42725 10.0935 8.23039 10.3848 8 10.6458C8.73295 11.4762 9.80531 12 11 12C13.2091 12 15 10.2091 15 8C15 5.79086 13.2091 4 11 4C9.80531 4 8.73294 4.52375 8 5.35418C8.23039 5.61521 8.42725 5.90655 8.58382 6.22144C9.13008 5.48059 10.0089 5 11 5C12.6569 5 14 6.34315 14 8C14 9.65685 12.6569 11 11 11C10.0089 11 9.13008 10.5194 8.58383 9.77856Z"
        fill="#404040"
      />
    </svg>
  );
};
